import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'

export default class SingleSearchArea extends Component {
  constructor (props) {
    super(props)
    this.state = {
      selectedValue: props.value,
      active: Boolean(props.value)
    }

    this.onSelectChangeBound = this.onSelectChange.bind(this)
    this.onClickBound = this.onClick.bind(this)
    this.onBlurBound = this.onBlur.bind(this)
    this[props.area] = React.createRef()
  }

  render () {
    const { label, area, options, placeholder, headerClass } = this.props

    return (
      <div
        className={`area ${area}-wrapper ${this.state.active ? 'active' : ''}`}
        onMouseDown={this.onClickBound}
        onBlur={this.onBlurBound}
      >
        {label && <label className={`header ${headerClass}`}>{label}</label>}
        <Select
          ref={this[area]}
          clearable
          single
          backspaceRemoves
          options={options}
          value={this.state.selectedValue}
          onChange={this.onSelectChangeBound}
          placeholder={placeholder}
          isLoading={this.props.loading}
        />
      </div>
    )
  }

  onSelectChange (value) {
    this.setState({ selectedValue: value })
    this.props.handleSelectChange(value)
  }

  onClick () {
    this.setState(() => {
      return {
        active: true
      }
    })
    if (!this.state.active) {
      setTimeout(() => {
        this[this.props.area].current.focus()
      }, 100)
    }
  }

  onBlur () {
    if (!this.state.selectedValue || this.state.selectedValue.length === 0) {
      this.setState(() => {
        return {
          active: false
        }
      })
    }
  }
}

SingleSearchArea.propTypes = {
  dispatch: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  label: PropTypes.string,
  area: PropTypes.string.isRequired,
  handleSelectChange: PropTypes.func.isRequired,
  value: PropTypes.object,
  placeholder: PropTypes.string,
  loading: PropTypes.bool,
  headerClass: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/mini/SingleSearchArea.js